import React from 'react';
import './Table.css';

// A recursive component to render a task and its children
const TaskRow = ({ project, task, level, onEdit, onDelete, onAddSubtask, onUpdateStatus, onAbortBidding, isAuthenticated }) => {
  return (
    <>
      <tr className={`task-level-${level}`}>
        <td className="task-name-cell" style={{ paddingLeft: `${level * 20 + 15}px` }}>{task.name}</td>
        <td>{task.assignee}</td>
        <td>{task.status}</td>
        <td>{task.hours}</td>
        <td>
          {isAuthenticated &&
          <button className="btn btn-sm btn-secondary" onClick={() => onEdit(task)}>编辑</button>
          }
          {isAuthenticated &&
          <button className="btn btn-sm btn-danger" onClick={() => onDelete(task.id)}>删除</button>
          }
          
          {task.status === '未开始' &&
            <button className="btn btn-sm btn-primary" onClick={() => onUpdateStatus(task.id)}>开始</button>
          }
          {task.status === '进行中' &&
            <button className="btn btn-sm btn-success" onClick={() => onUpdateStatus(task.id)}>完成</button>
          }

          {task.name === '招标文件研读' && task.status === '进行中' && project.bid_status !== 'aborted' &&
            <button className="btn btn-sm btn-warning" onClick={onAbortBidding}>标书不适合投标</button>
          }

          {level === 0 && (
             <button className="btn btn-sm" onClick={() => onAddSubtask(task.id)}>添加子任务</button>
          )}
        </td>
      </tr>
      {task.children && task.children.map(child => (
        <TaskRow 
            key={child.id}
            project={project}
            task={child} 
            level={level + 1}
            onEdit={onEdit}
            onDelete={onDelete}
            onAddSubtask={onAddSubtask}
            onUpdateStatus={onUpdateStatus}
            onAbortBidding={onAbortBidding}
            isAuthenticated={isAuthenticated}
        />
      ))}
    </>
  );
};

const TaskTable = ({ project, tasks, onEdit, onDelete, onAddSubtask, onUpdateStatus, onAbortBidding, isAuthenticated }) => {
  const buildTree = (taskList) => {
    if (!taskList || taskList.length === 0) return [];

    const map = new Map();
    taskList.forEach(task => {
        map.set(task.id, { ...task, children: [] });
    });

    const roots = [];
    taskList.forEach(task => {
        if (task.parentId && map.has(task.parentId)) {
            map.get(task.parentId).children.push(map.get(task.id));
      } else {
            roots.push(map.get(task.id));
        }
    });

    const sortBySequence = (a, b) => {
        const seqA = a.sequence !== null ? a.sequence : Infinity;
        const seqB = b.sequence !== null ? b.sequence : Infinity;
        return seqA - seqB;
    };

    roots.sort(sortBySequence);

    map.forEach(node => {
        if (node.children.length > 1) {
            node.children.sort(sortBySequence);
      }
    });

    return roots;
  };
  
  const taskTree = buildTree(tasks);

  if (!tasks || tasks.length === 0) {
    return <p>请先从上方选择一个项目以查看其任务，或为此项目添加新任务。</p>;
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th className="task-name-cell">任务名称</th>
            <th>负责人</th>
            <th>状态</th>
            <th>估算工时(小时)</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {taskTree.map(task => (
            <TaskRow 
                key={task.id} 
                project={project}
                task={task} 
                level={0}
                onEdit={onEdit}
                onDelete={onDelete}
                onAddSubtask={onAddSubtask}
                onUpdateStatus={onUpdateStatus}
                onAbortBidding={onAbortBidding}
                isAuthenticated={isAuthenticated}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskTable; 